import { FormType } from '../../../form-types';
import { MicroGlp1FieldAnswers } from './questions';

const microGlp1: FormType<MicroGlp1FieldAnswers> = {
  name: 'GIP/GLP-1 Microdosing',
  questions: [
    //* This has been removed from the flow, keep in the questions for backwards compatibility
    // {
    //   key: 'microGlp1_initialConsent',
    //   next: {
    //     condition: { 'microGlp1_initialConsent.no': true },
    //     key: 'microGlp1_didNotConsent',
    //     els: 'microGlp1_weightAndHeight2025'
    //   }
    // },
    'microGlp1_weightAndHeight2025',
    {
      key: 'microGlp1_sex',
      next: {
        condition: { 'microGlp1_sex.female': true },
        key: 'microGlp1_pregnancyStatus',
        els: 'microGlp1_desiredOutcomes'
      }
    },
    {
      key: 'microGlp1_pregnancyStatus',
      next: {
        condition: { 'microGlp1_pregnancyStatus.yes': true },
        key: 'microGlp1_ineligible',
        els: 'microGlp1_consentPregnancy'
      }
    },
    {
      key: 'microGlp1_consentPregnancy',
      next: {
        condition: { 'microGlp1_consentPregnancy.non_consent': true },
        key: 'microGlp1_didNotConsent',
        els: 'microGlp1_desiredOutcomes'
      }
    },
    'microGlp1_desiredOutcomes',
    'microGlp1_concernDuration',
    {
      key: 'microGlp1_priorGlp1Use',
      next: {
        condition: { 'microGlp1_priorGlp1Use.yes': true },
        key: 'microGlp1_priorGlp1Medications',
        els: 'microGlp1_medicalHistory'
      }
    },
    'microGlp1_priorGlp1Medications',
    {
      key: 'microGlp1_priorSideEffects',
      next: {
        condition: { 'microGlp1_priorSideEffects.yes': true },
        key: 'microGlp1_sideEffectsDescription',
        els: 'microGlp1_medicalHistory'
      }
    },
    'microGlp1_sideEffectsDescription',
    {
      key: 'microGlp1_medicalHistory',
      next: {
        switch: [
          {
            condition: { 'microGlp1_medicalHistory.gastroparesis': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.high_triglycerides': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.pancreatic_cancer': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.pancreatitis': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.type1_diabetes': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.hypoglycemia': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: {
              'microGlp1_medicalHistory.insulin_dependent_diabetes': true
            },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.thyroid_cancer': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.men2_syndrome': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.eating_disorder': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: {
              'microGlp1_medicalHistory.symptomatic_gallstones': true
            },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.type2_diabetes': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.ckd': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.liver_failure': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: {
              'microGlp1_medicalHistory.uncontrolled_heart_disease': true
            },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.siadh': true },
            key: 'microGlp1_ineligible'
          },
          {
            condition: { 'microGlp1_medicalHistory.gallbladder': true },
            key: 'microGlp1_consentGallbladder'
          },
          {
            condition: { 'microGlp1_medicalHistory.none': true },
            key: 'microGlp1_gastricBypass'
          }
        ]
      }
    },

    {
      key: 'microGlp1_consentGallbladder',
      next: {
        condition: { 'microGlp1_consentGallbladder.non_consent': true },
        key: 'microGlp1_didNotConsent',
        els: 'microGlp1_gastricBypass'
      }
    },
    {
      key: 'microGlp1_gastricBypass',
      next: {
        condition: { 'microGlp1_gastricBypass.yes': true },
        key: 'microGlp1_ineligible',
        els: 'microGlp1_medicationAllergies'
      }
    },
    {
      key: 'microGlp1_medicationAllergies',
      next: {
        condition: {
          'microGlp1_medicationAllergies.none': true
        },
        key: 'microGlp1_contraindicatedMedications',
        els: 'microGlp1_ineligible'
      }
    },
    {
      key: 'microGlp1_contraindicatedMedications',
      next: {
        condition: { 'microGlp1_contraindicatedMedications.yes': true },
        key: 'microGlp1_ineligible',
        els: 'microGlp1_additionalQuestions'
      }
    },
    'microGlp1_additionalQuestions',
    {
      key: 'microGlp1_consentTruthfulness',
      next: {
        condition: { 'microGlp1_consentTruthfulness.non_consent': true },
        key: 'microGlp1_didNotConsent',
        els: 'microGlp1_consentMedicationSpecific'
      }
    },
    {
      key: 'microGlp1_consentMedicationSpecific',
      next: {
        condition: { 'microGlp1_consentMedicationSpecific.non_consent': true },
        key: 'microGlp1_didNotConsent',
        els: 'microGlp1_complete'
      }
    },
    'microGlp1_ineligible',
    'microGlp1_didNotConsent',
    'microGlp1_complete'
  ]
};

export default microGlp1;
